import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

import useMenuContent from '@/utils/useMenuContent';

import { containerVariants } from './utils';
import ItemMenu from './ItemMenu';

const MobileMenu = ({ isOpen, classes, currentPath, ...rest }) => {
  const menu = useMenuContent();

  return (
    <motion.div
      className={classes.container}
      variants={containerVariants}
      animate={isOpen ? 'openMenu' : 'closeMenu'}
      initial="closeMenu"
    >
      {(currentPath === '/' ? menu.slice(1) : menu).map(({ name, to }, index) => (
        <ItemMenu
          key={to || index}
          name={name}
          to={to}
          disabled={to === currentPath || (to === '/news/' && currentPath.includes('/news/'))}
          {...rest}
        />
      ))}
    </motion.div>
  );
};

MobileMenu.defaultProps = {
  isOpen: false,
};

MobileMenu.propTypes = {
  isOpen: PropTypes.bool,
  currentPath: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default MobileMenu;
